export default {
    namespaced: true,
    state: {
		title: '',
		params: {
			vin: null,
		},
        data: {},
    },
}